import { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import Routera from "./Router";
import axios from "axios";
import { getTenantConfig, buildAssetPath } from "../tenant/tenantConfig";
import { PUBLIC_URL } from "../serviceWorker";

const App = () => {
  axios.defaults.withCredentials = true;
  document.addEventListener("message", function () {
    //let token = data.data;
  });

  useEffect(() => {
    const tenant = getTenantConfig();

    const setFavicon = (rel: string, url: string) => {
      let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.href = url;
    };

    const faviconUrl = PUBLIC_URL + buildAssetPath(tenant.shopId, tenant.faviconFile);
    setFavicon("icon", faviconUrl);
    setFavicon("apple-touch-icon", faviconUrl);

    document.title = tenant.pageTitle;

    const setMeta = (attr: "name" | "property", key: string, content: string) => {
      const selector = `meta[${attr}="${key}"]`;
      let meta = document.querySelector<HTMLMetaElement>(selector);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attr, key);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    const sm = (name: string, content: string) => setMeta("name", name, content);
    const sp = (prop: string, content: string) => setMeta("property", prop, content);

    sm("description", tenant.metaDescription);
    sm("theme-color", tenant.primaryColor);
    sp("og:title", tenant.pageTitle);
    sp("og:description", tenant.metaDescription);
    sp("og:site_name", tenant.brandName);
    sp("og:type", "website");
    sp("og:url", window.location.href);

    const ogImageFile = tenant.ogImageFile || tenant.faviconFile;
    const ogImageUrl = window.location.origin + PUBLIC_URL + buildAssetPath(tenant.shopId, ogImageFile);
    sp("og:image", ogImageUrl);

    sm("twitter:card", "summary_large_image");
  }, []);

  return (
    <Provider store={store}>
      <Routera />
    </Provider>
  );
};

export default App;
